
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    MissingTranslationHandler,
    TranslateLoader,
    TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { BookingCancelationComponent } from './components/booking-cancelation/booking-cancelation.component';
import { CancellationReasonPopupComponent } from './components/cancellation-reason-popup/cancellation-reason-popup.component';
import { BookingHistoryTripDetailsComponent } from './components/booking-history-trip-details/booking-history-trip-details.component';
import { BookingUserDetailsComponent } from './components/booking-user-details/booking-user-details.component';
import { CancelSaleQuotationComponent } from './components/cancel-sale-quotation/cancel-sale-quotation.component';
import { BookingDriverDetailsComponent } from './components/driver-details/booking-driver-details.component';
import { EditableEmployeeComponent } from './components/editable-employee/editable-employee.component';
import { EmployeeTripDetailsComponent } from './components/employee-trip-details/employee-trip-details.component';
import { EmployeeUserDetailsComponent } from './components/employee-user-details/employee-user-details.component';
import { NavtabComponent } from './components/navtab/navtab.component';
import { TripDetailsComponent } from './components/trip-details/trip-details.component';
import { TripMapComponent } from './components/trip-map/trip-map.component';
import { UploadQuoteComponent } from './components/upload-quote/upload-quote.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SidebarModule } from 'primeng/sidebar';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';

import {
    EditablePricingChauffeurComponent
} from 'app/modules/shared/components/editable-pricing-chauffeur/editable-pricing-chauffeur.component';
import { FieldsetModule } from 'primeng/fieldset';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { AssignDriverComponent } from './components/assign-driver/assign-driver.component';
import { AssignSearchComponent } from './components/assign-search/assign-search.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { BookChauffeurComponent } from './components/book-chauffeur/book-chauffeur.component';
import { BookRentalComponent } from './components/book-rental/book-rental.component';
import { BookTaxiComponent } from './components/book-taxi/book-taxi.component';
import { BookingHistoryDetailsComponent } from './components/booking-history-details/booking-history-details.component';
import { BreadCrumbsComponent } from './components/bread-crumbs/bread-crumbs.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CommentInfoComponent } from './components/comment-info/comment-info.component';
import { CommentReplyComponent } from './components/comment-reply/comment-reply.component';
import { DashboardActivityComponent } from './components/dashboard-activity/dashboard-activity.component';
import { DashboardStatsCountsComponent } from './components/dashboard-stats-counts/dashboard-stats-counts.component';
import { DevelopementInProgressComponent } from './components/developement-in-progress/developement-in-progress.component';
import { EditPartnerRoutesComponent } from './components/edit-partner-routes/edit-partner-routes.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { EditRentalPartnerPricingComponent } from './components/edit-rental-partner-pricing/edit-rental-partner-pricing.component';
import { EditTaxiPartnerPricingComponent } from './components/edit-taxi-partner-pricing/edit-taxi-partner-pricing.component';
import { FileUploaderComponent } from './components/file-uploader/file.uploader.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { HeaderComponent } from './components/header/header.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './components/loader/loader.service';
import { LogDeailsComponent } from './components/log-deails/log-deails.component';
import { MergeBookingPopupComponent } from './components/merge-booking-popup/merge-booking-popup.component';
import { MessageComponent } from './components/message/message.component';
import { MiFilterComponent } from './components/mi-filter/mi-filter.component';
import { MiGrid2Component } from './components/mi-grid-2/mi-grid-2.component';
import { NotificationMG1Component } from './components/notification-mg1/notification-mg1.component';
import { OtpVerifiyComponent } from './components/otp-verifiy/otp-verifiy.component';
import { OtpComponent } from './components/otp/otp.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PassengerDayBookingsComponent } from './components/passenger-day-bookings/passenger-day-bookings.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { RecentEmergencyRequestComponent } from './components/recent-emergency-request/recent-emergency-request.component';
import { RentalDocsComponent } from './components/rental-docs/rental-docs.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { SharedAllBookingsComponent } from './components/shared-all-bookings/shared-all-bookings.component';
import { SharedBookingsListComponent } from './components/shared-bookings-list/shared-bookings-list.component';
import { SharedCriticalJourneyComponent } from './components/shared-critical-journey/shared-critical-journey.component';
import { SharedInboundOtherJourneyComponent } from './components/shared-inbound-other-journey/shared-inbound-other-journey.component';
import { SharedLuggageRequestComponent } from './components/shared-luggage-request/shared-luggage-request.component';
import { SharedMergeBookingsComponent } from './components/shared-merge-bookings/shared-merge-bookings.component';
import { SharedOtherJourneyComponent } from './components/shared-other-journey/shared-other-journey.component';
import { SharedOutboundJourneyComponent } from './components/shared-outbound-journey/shared-outbound-journey.component';
import { SharedThirdPartyTransferComponent } from './components/shared-third-party-transfer/shared-third-party-transfer.component';
import { SharedVehicleTransferComponent } from './components/shared-vehicle-transfer/shared-vehicle-transfer.component';
import { AssignDriverV2Component } from './components/assign-driver-v2/assign-driver-v2.component';
import { AssignDriverMapComponent } from './components/assign-driver-map/assign-driver-map.component';
import { UpcomingBookingsComponent } from './components/upcoming-bookings/upcoming-bookings.component';
import { SidebarAssignDriverComponent } from './components/sidebar-assign-driver/sidebar-assign-driver.component';
import { SidebarBookingDetailsComponent } from './components/sidebar-booking-details/sidebar-booking-details.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TotalAndActiveCountsComponent } from './components/total-and-active-counts/total-and-active-counts.component';
import { TrackLocationComponent } from './components/track-location/track-location.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { AccessProviderDirective } from './directives/access-provider.directive';
import { DisableControlDirective } from './directives/input-disabled.directive';
import { LogicalAccessProviderDirective } from './directives/logical-access-provider.directive';
import { RippleDirective } from './directives/ripple.directive';
import { SearchLocationDirective } from './directives/search-location.directive';
import { AgoPipe } from './pipes/ago.pipe';
import { DateFormatPipe } from './pipes/dateformat.pipe';
import { DateTimeFormatPipe } from './pipes/datetimeformat.pipe';
import { KeepHtmlPipe } from './pipes/keep-html.pipe';
import { MiliSecondToMinutesPipe } from './pipes/miliSecondToMinutes.pipe';
import { MinutsFormatPipe } from './pipes/minutesformat.pipe';
import { SlotsTimeOnlyPipe } from './pipes/slots-time-only.pipe';
import { AuthenticationValidationService } from './services/authentication-validation.service';
import { CommonBindingDataService } from './services/common-binding-data.service';
import { ErrorBindingService } from './services/error-binding.service';
import { MiMissingTranslationHandlerService } from './services/mi-missing-translation-handler.service';
import { MiTranslateLoaderService } from './services/mi-translate-loader.service';
import { RestApiService } from './services/rest-api.service';
import { SidebarService } from './services/sidebar.service';
import { StorageService } from './services/storage.service';
import { UiService } from './services/ui.service';
import { UserCommonService } from './services/user-common.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PanelMenuModule,
    RatingModule,
    ButtonModule,
    EditorModule,
    ConfirmDialogModule,
    CalendarModule,
    ChartModule,
    MenuModule,
    DropdownModule,
    RadioButtonModule,
    CheckboxModule,
    FieldsetModule,
    DialogModule,
    FormsModule,
    FileUploadModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    TableModule,
    PaginatorModule,
    BlockUIModule,
    OverlayPanelModule,
    TabMenuModule,
    TabViewModule,
    SidebarModule,
    PasswordModule,
    InputSwitchModule,
    InputTextModule,
    ToastModule,
    MultiSelectModule,
    AccordionModule,
    SelectButtonModule,
    ToggleButtonModule,
    SplitButtonModule,
    OverlayPanelModule,
    // KeyFilterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: MiTranslateLoaderService
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MiMissingTranslationHandlerService
      }
    }),
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    PageHeaderComponent,
    DisableControlDirective,
    SearchLocationDirective,
    ChangePasswordComponent,
    EditProfileComponent,
    KeepHtmlPipe,
    AssignSearchComponent,
    PieChartComponent,
    BarChartComponent,
    DashboardStatsCountsComponent,
    DashboardActivityComponent,
    LoaderComponent,
    FileUploaderComponent,
    AgoPipe,
    MiliSecondToMinutesPipe,
    DateFormatPipe,
    DateTimeFormatPipe,
    MinutsFormatPipe,
    SlotsTimeOnlyPipe,
    TotalAndActiveCountsComponent,
    BookingDriverDetailsComponent,
    BookingUserDetailsComponent,
    TripDetailsComponent,
    TripMapComponent,
    UploadQuoteComponent,
    NotificationMG1Component,
    CommentInfoComponent,
    CommentReplyComponent,
    ForgotPasswordComponent,
    OtpVerifiyComponent,
    BookingHistoryDetailsComponent,
    BookingHistoryTripDetailsComponent,
    EmployeeUserDetailsComponent,
    EditableEmployeeComponent,
    EmployeeTripDetailsComponent,
    CancelSaleQuotationComponent,
    EditablePricingChauffeurComponent,
    OtpVerifiyComponent,
    SetPasswordComponent,
    EditTaxiPartnerPricingComponent,
    EditRentalPartnerPricingComponent,
    EditPartnerRoutesComponent,
    RentalDocsComponent,
    NavtabComponent,
    BookTaxiComponent,
    BookRentalComponent,
    BookChauffeurComponent,
    BookingCancelationComponent,
    CancellationReasonPopupComponent,
    RecentEmergencyRequestComponent,
    OtpComponent,
    TrackLocationComponent,
    AccessProviderDirective,
    MiGrid2Component,
    MiFilterComponent,
    AssignDriverComponent,
    LogDeailsComponent,
    SharedBookingsListComponent,
    SharedCriticalJourneyComponent,
    SharedOutboundJourneyComponent,
    SharedVehicleTransferComponent,
    MessageComponent,
    SidebarAssignDriverComponent,
    BreadCrumbsComponent,
    UpdatePasswordComponent,
    SharedThirdPartyTransferComponent,
    DevelopementInProgressComponent,
    RippleDirective,
    SidebarBookingDetailsComponent,
    PassengerDayBookingsComponent,
    LogicalAccessProviderDirective,
    SharedOtherJourneyComponent,
    SharedInboundOtherJourneyComponent,
    SharedLuggageRequestComponent,
    SharedMergeBookingsComponent,
    SharedAllBookingsComponent,
    MergeBookingPopupComponent,
    AssignDriverV2Component,
    AssignDriverMapComponent,
    UpcomingBookingsComponent
  ],
  exports: [
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    SidebarComponent,
    PageHeaderComponent,
    TranslateModule,
    ConfirmDialogModule,
    DialogModule,
    SearchLocationDirective,
    AccessProviderDirective,
    DisableControlDirective,
    AssignSearchComponent,
    PieChartComponent,
    BarChartComponent,
    DashboardStatsCountsComponent,
    DashboardActivityComponent,
    LoaderComponent,
    FileUploaderComponent,
    AgoPipe,
    MiliSecondToMinutesPipe,
    DateFormatPipe,
    DateTimeFormatPipe,
    KeepHtmlPipe,
    MinutsFormatPipe,
    SlotsTimeOnlyPipe,
    TotalAndActiveCountsComponent,
    BookingDriverDetailsComponent,
    BookingUserDetailsComponent,
    TripDetailsComponent,
    TripMapComponent,
    UploadQuoteComponent,
    NotificationMG1Component,
    CommentInfoComponent,
    ForgotPasswordComponent,
    OtpVerifiyComponent,
    BookingHistoryDetailsComponent,
    BookingHistoryTripDetailsComponent,
    EmployeeUserDetailsComponent,
    EditableEmployeeComponent,
    EmployeeTripDetailsComponent,
    CancelSaleQuotationComponent,
    EditablePricingChauffeurComponent,
    SetPasswordComponent,
    EditTaxiPartnerPricingComponent,
    EditRentalPartnerPricingComponent,
    EditPartnerRoutesComponent,
    RentalDocsComponent,
    NavtabComponent,
    BookTaxiComponent,
    BookRentalComponent,
    BookChauffeurComponent,
    BookingCancelationComponent,
    CancellationReasonPopupComponent,
    RecentEmergencyRequestComponent,
    OtpComponent,
    MiGrid2Component,
    MiFilterComponent,
    TrackLocationComponent,
    AssignDriverComponent,
    LogDeailsComponent,
    SharedBookingsListComponent,
    MessageComponent,
    SidebarAssignDriverComponent,
    BreadCrumbsComponent,
    UpdatePasswordComponent,
    RippleDirective,
    DevelopementInProgressComponent,
    MultiSelectModule,
    AccordionModule,
    SelectButtonModule,
    SidebarBookingDetailsComponent,
    PassengerDayBookingsComponent,
    LogicalAccessProviderDirective,
    TabMenuModule,
    CheckboxModule,
    CalendarModule,
    FieldsetModule,
    AutoCompleteModule,
    TableModule,
    SplitButtonModule,
    MergeBookingPopupComponent,
    AssignDriverV2Component,
    AssignDriverMapComponent,
    UpcomingBookingsComponent,
    // KeyFilterModule
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LoaderService,
        RestApiService,
        UiService,
        UserCommonService,
        StorageService,
        ErrorBindingService,
        CommonBindingDataService,
        SearchLocationDirective,
        DisableControlDirective,
        AuthenticationValidationService,
        ConfirmationService,
        TranslateService,
        SidebarService,
      ]
    };
  }

  constructor(translate: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

  }

}
